import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { backend_url } from "../../App";
import HeaderTitle from "../HederTitle/HeaderTitle";
import designPattrns from "../Design/Design.css";

const ImageGrid = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  const allPlaces = ["Place 2", "Place 1", "Place 4", "Place 3", "Place 5"];

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/designpatterns`);
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const placeMap = {};
  categories.forEach((category) => {
    placeMap[category.placeTo] = category;
  });

  return (
    <div className="p-4 w-11/12 mx-auto">
      <HeaderTitle Header="Shop By Design Patterns" />

      {/* Mobile: Single column (flex for scrolling) */}
      {/* <div className="flex overflow-x-auto gap-4 md:hidden no-scrollbar pb-4"> */}
      <div className="flex flex-col overflow-y-auto gap-4 md:hidden no-scrollbar pb-4">
        {allPlaces.map((place, index) => {
          const item = placeMap[place];
          return (
            <div
              key={index}
              className="min-w-[250px] flex-shrink-0 text-center p-4 pb-8 gap-2 flex flex-col items-center bg-purple-200 rounded-lg"
              onClick={() =>
                item?.routeTo && navigate(`/collections/${item.routeTo}`)
              }
              style={{ cursor: item?.routeTo ? "pointer" : "default" }}
            >
              {item ? (
                <>
                  <img
                    crossOrigin="anonymous"
                    src={
                      item.image.startsWith("http")
                        ? item.image
                        : `${item.image}`
                    }
                    alt={item.collectionName}
                    className="w-full h-[400px] object-cover mb-2 border-[5px] border-[#cdb5e5]  rounded-[26px]"
                  />
                  <div className="absolute w-full h-3/4 bottom-1 left-1 -z-10 rounded-br-3xl bg-purple-300"></div>
                  <div className="text-xs italic">Design Pattern</div>
                  <div
                    className={`text-base font-semibold ${
                      item.collectionName === "Plain Fabric"
                        ? "text-red-500"
                        : "text-gray-800"
                    }`}
                  >
                    {item.collectionName}
                  </div>
                  <div className="text-xs text-gray-600">
                    Starting from ₹{item.startingFrom}
                  </div>
                </>
              ) : (
                <div className="text-gray-400 text-sm">{place}</div>
              )}
            </div>
          );
        })}
      </div>

      {/* Desktop/Laptop: Grid with larger center image */}
      <div className="hidden md:grid md:grid-cols-4 gap-6 px-2">
        {allPlaces.map((place, index) => {
          const item = placeMap[place];
          const isCenterItem = index === 1; // This is the item we want to make larger on desktop

          return (
            <div
              key={index}
              className={`relative text-center p-4 pb-8 gap-2 flex flex-col items-center ${
                isCenterItem ? "md:col-span-2 md:row-span-2" : ""
              }`}
              onClick={() =>
                item?.routeTo && navigate(`/collections/${item.routeTo}`)
              }
              style={{ cursor: item?.routeTo ? "pointer" : "default" }}
            >
              {item ? (
                <>
                  <img
                    crossOrigin="anonymous"
                    src={
                      item.image.startsWith("http")
                        ? item.image
                        : `${item.image}`
                    }
                    alt={item.collectionName}
                    className={`w-full object-cover mb-2 border-[5px] border-[#cdb5e5] rounded-[26px]   ${
                      isCenterItem ? "md:h-[750px] md:mt-16" : "h-[22rem]"
                    }`}
                  />
                  <div className="absolute w-full h-3/4 bottom-1 left-1 -z-10 rounded-br-3xl rounded-md"></div>
                  <div className="text-xs italic">Design Pattern</div>
                  <div
                    className={`text-base font-semibold ${
                      item.collectionName === "Plain Fabric"
                        ? "text-red-500"
                        : "text-gray-800"
                    }`}
                  >
                    {item.collectionName}
                  </div>
                  <div className="text-xs text-gray-600">
                    Starting from ₹{item.startingFrom}
                  </div>
                </>
              ) : (
                <div className="text-gray-400 text-sm">{place}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImageGrid;
